import { extractInboxName, useInboxNames } from '~/entities/data-sources'
import { RadioButton, Text } from '~/shared/ui'
import { useFilters } from '../../../model'

export function SourceFilter() {
  const { filters, setFilters } = useFilters()
  const { data: inboxNames } = useInboxNames()

  return inboxNames.inbox_names.map((inboxName) => {
    const { name, description } = extractInboxName(inboxName)
    return (
      <div
        key={inboxName}
        className="flex items-center px-2 py-0.5"
      >
        <RadioButton
          className="max-w-[255px]"
          label={
            <div className="flex flex-col">
              <Text appearance="BODY2">{name}</Text>
              <Text
                className="text-text-tertiary"
                appearance="CAPTION"
              >
                {description}
              </Text>
            </div>
          }
          gutter
          size="small"
          checked={filters.source === inboxName}
          onChange={() => {
            setFilters({
              source: inboxName,
            })
          }}
        />
      </div>
    )
  })
}
